import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CityService } from '../../services/city.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { CheckCall, City, QuoteOrder, QuoteOrderLine, SearchOrderEventType, SearchQuoteOrderLine } from '../../models/models';

@Component({
    selector: 'check-call-form',
    templateUrl: './check-call-form.component.html',
    standalone: false
})
export class CheckCallForm implements OnChanges {
    @Input() checkCallID: number = 0;
    @Input() quoteOrderLineID: number = 0;
    @Input() quoteOrderID: number = 0;
    //@Input() checkCall: CheckCall = {} as CheckCall;
    @Input() viewType: string = "quoteorder";
    @Output() onRefresh = new EventEmitter<any>();

    public checkCall: CheckCall = {} as CheckCall;
    public quoteOrder: QuoteOrder = {} as QuoteOrder;
    public quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    public quoteOrderLineList: QuoteOrderLine[] = [];
    //private searchOrderEventTypes: SearchOrderEventType[] = [];
    public orderEventTypeList: SearchOrderEventType[] = []; //['CHK', 'FUT', 'TRP'];
    private checkCallCity: City = {} as City;
    public defaultCheckCallCity: string = "";
    //public cityControl = new FormControl();

    public checkCallForm: UntypedFormGroup = new UntypedFormGroup({
        cityControl: new UntypedFormControl('')
    });

    constructor(private cityService: CityService, private orderService: OrderService, private notificationService: NotificationService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.getOrderEventTypes();
        //console.log("ngOnInit", this.checkCall);
    }

    ngOnChanges() {
        if (this.checkCallID == 0) {
            this.getNewCheckCall();
        }
        else {
            this.orderService.getCheckCallByID(this.checkCallID).subscribe(result => {
                this.checkCall = result.resultCollection[0];
                this.checkCall.dateOfCall = new Date(this.checkCall.dateOfCall);
            });
        }

        if (this.checkCall.cityId > 0) {
            this.setDefaultCheckCallCity();
        }

        if (this.quoteOrderID > 0) {
            this.utilService.isLoading = true;
            this.orderService.getQuoteOrderLinesByQuoteOrderID(this.quoteOrderID).subscribe(result2 => {
                this.utilService.isLoading = false;
                this.quoteOrderLineList = result2.resultCollection;
            });
        }
        else if (this.quoteOrderLineID > 0) {
            this.utilService.isLoading = true;
            this.orderService.getQuoteOrderLineById(this.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result != null) {
                    this.utilService.isLoading = true;
                    this.quoteOrderLine = result;
                    this.orderService.getQuoteOrderLinesByQuoteOrderID(this.quoteOrderLine.quoteOrderID).subscribe(result2 => {
                        this.utilService.isLoading = false;
                        this.quoteOrderLineList = result2.resultCollection;
                    });
                }
            });
        }

        //console.log("ngOnChanges", this.checkCall);
    }

    private getNewCheckCall() {
        var employeeID = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);
        var checkCallType = "Manual CHK";
        var checkCall = {
            quoteOrderLineId: this.quoteOrderLineID,
            quoteOrderID: this.quoteOrderID,
            legHeaderNumber: 0, //(this.searchLineorline.apiLoadId == null ? 0 : this.line.apiLoadId),
            //quoteOrderLineId: this.checkCallList[0].quoteOrderLineId,
            //legHeaderNumber: this.checkCallList[0].legHeaderNumber,
            checkCallAction: checkCallType,
            status: 'HIST',
            assignType: 'CAR',
            //assignId: this.checkCallList[0].assignId,
            cityId: 0,
            comment: '',
            dateOfCall: new Date(),
            eventCode: 'CHK',
            tractorNumber: 'UNKNOWN',
            lateInd: false,
            cautionInd: false,
            createdByEmployeeId: employeeID,
            createdDate: new Date()
        } as CheckCall;
        this.checkCall = checkCall;
    }

    private getOrderEventTypes() {
        var eventType = "Check Call";
        if (this.viewType == "customs-exceptions") {
            eventType = "Customs & Exceptions";
        }
        this.orderService.getGetSearchOrderEventTypeByEventTypeName(eventType).subscribe(result => {
            var checkCallCodes = result;
            if (this.viewType == "customer") {
                checkCallCodes = checkCallCodes.filter(t => t.isCustomerVisible == true);
            }
            checkCallCodes = result.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.orderEventTypeList = checkCallCodes;
        });
    }

    private setDefaultCheckCallCity() {
        this.checkCallCity = this.checkCall.city;
        this.defaultCheckCallCity = this.checkCall.city.cityST;
        this.cityService.getCityByID(this.checkCall.cityId).subscribe(result => {
            var cityList = result.resultCollection;
            if (cityList.length > 0) {
                var city = cityList[0] as City;
                this.checkCallForm.controls['checkCallCityControl'].setValue(city);
            }
            else if (this.checkCall.city != null) {
                this.checkCallForm.controls['checkCallCityControl'].setValue(this.checkCall.city);
            }
        });
    }

    public save() {
        if (this.checkCall.quoteOrderLineId == 0 && this.viewType != "customs-exceptions") {
            this.notificationService.showError("Load # required.", "ERROR: Load # Required");
        }
        else {
            this.utilService.isLoading = true;
            var city = this.checkCallForm.controls['cityControl'].value as City;
            if (city.cityID) {
                this.checkCall.cityId = city.cityID;
            }
            var checkCall = Object.assign({}, this.checkCall);
            checkCall.dateOfCall = this.utilService.getDateAsUTC(checkCall.dateOfCall);
            if (checkCall.orderEventTypeID == null) {
                var orderEventTypes = this.orderEventTypeList.filter(t => t.code == checkCall.eventCode);
                if (orderEventTypes.length > 0) {
                    checkCall.orderEventTypeID = orderEventTypes[0].orderEventTypeID;
                }
            }
            else {
                var orderEventTypes = this.orderEventTypeList.filter(t => t.orderEventTypeID == checkCall.orderEventTypeID);
                if (orderEventTypes.length > 0) {
                    checkCall.eventCode = orderEventTypes[0].code;
                }
            }
            //console.log("save", checkCall);
            this.orderService.saveCheckCall(checkCall).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.checkCallId > 0) {
                    //this.getCustomers();
                    this.onRefresh.emit();
                } else {
                    this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                }
            });

            this.checkCall = {} as CheckCall;
        }
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
